module.exports = __webpack_public_path__ + "img/lala_scroll01.97be8344.webp";